import { css } from '@emotion/react'
import { Button, Heading, HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { ReactComponent as AvisoCidadaoCdsIcon } from 'images/cidadao/aviso-cidadao-cds.svg'

interface CardNovidadesCidadaoProps {
  onClickAcaoPrincipal?: () => void
  labelAcaoPrincipal?: string
}

export function CardNovidadesCidadao({
  onClickAcaoPrincipal,
  labelAcaoPrincipal = 'Ver principais mudanças',
}: Readonly<CardNovidadesCidadaoProps>) {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <HFlow hSpacing={1} alignItems='center' style={styles.container}>
      <AvisoCidadaoCdsIcon css={styles.img} />
      <VFlow vSpacing={0.5} style={styles.text}>
        <Heading level={3}>O antigo módulo do cidadão evoluiu e agora se chama Cadastro Individual!</Heading>
        <Text>
          Ele passa a centralizar a gestão dos cadastros individuais, eliminando a necessidade de usar o CDS. Esse novo
          módulo também funciona de forma conectada ao Acompanhamento do Território, de modo que atualizações feitas
          aqui refletem na formação da família e na vinculação ao território.
        </Text>
        {onClickAcaoPrincipal && (
          <Button skin='outline' kind='primary' size='small' onClick={onClickAcaoPrincipal}>
            {labelAcaoPrincipal}
          </Button>
        )}
      </VFlow>
    </HFlow>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    padding: 0.75rem 1.5rem;
    outline: 1px solid ${theme.pallete.gray.c60};
    background-color: ${theme.pallete.surface.main};
    border-radius: 0.4rem;
    min-height: 150px;
  `,
  text: css`
    max-width: 55rem;
  `,
  img: css`
    align-self: flex-end;
    margin-bottom: -0.75rem;
  `,
})
